import React, { useState } from 'react';
import { Box, Typography, Radio, CardMedia, Button } from '@material-ui/core';
import ImageDropzone from './ImageDropzone/ImageDropzone';
import useStyles from './ImportImage.styles';

import InputForm from '../InputForm/InputForm';
import { useTranslation } from 'react-i18next';
import tPaths from '../../utils/tPaths';
import { IEditForm } from '../../types/interfaces/IEditForm';

const ImportImage: React.FC<IEditForm> = (props) => {
  const { label, value, onChange, fieldName } = props;

  const styles = useStyles();
  const [isUpload, setIsUpload] = useState(true);
  const { t } = useTranslation();

  return (
    <Box className={styles.container}>
      {label && (
        <Typography variant="subtitle2" style={{ fontWeight: 'bold' }}>
          {label}
        </Typography>
      )}
      {value ? (
        <Box className={styles.imagePreviewContainer}>
          <CardMedia
            src={value}
            component="img"
            alt={value}
            style={{
              height: 249,
              width: 'auto',
              margin: 'auto',
            }}
            onClick={() => window.open(value, '_blank')}
          />
          <Box
            style={{
              position: 'absolute',
              margin: 16,
              bottom: 0,
              right: 0,
            }}
          >
            <Button onClick={() => (onChange ? onChange(fieldName, null) : null)}>
              {t(tPaths.imageUpload.changeImage)}
            </Button>
          </Box>
        </Box>
      ) : (
        <Box height={251} marginTop={1}>
          <Box className={styles.selectUploadContainer}>
            <Box onClick={() => setIsUpload(true)} className={styles.selectUploadContainer}>
              <Radio checked={isUpload} onChange={() => setIsUpload(true)} />
              <Typography variant="subtitle1" className={styles.marginRight}>
                {t(tPaths.imageUpload.upload)}
              </Typography>
            </Box>
            <Box onClick={() => setIsUpload(false)} className={styles.selectUploadContainer}>
              <Radio checked={!isUpload} onChange={() => setIsUpload(false)} />
              <Typography variant="subtitle1">{t(tPaths.imageUpload.pasteUrl)}</Typography>
            </Box>
          </Box>
          {isUpload ? (
            <ImageDropzone onChange={(url) => (onChange ? onChange(fieldName, url) : null)} />
          ) : (
            <InputForm {...props} label={null} />
          )}
        </Box>
      )}
    </Box>
  );
};

export default ImportImage;
